// extracted by mini-css-extract-plugin
module.exports = {"errorText":"LegalEntityBasicData_errorText__Kx4VB","pendingMessage":"LegalEntityBasicData_pendingMessage__Lk8xc"};